"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderPopupEnum = void 0;
var HeaderPopupEnum;
(function (HeaderPopupEnum) {
    HeaderPopupEnum["Language"] = "language";
    HeaderPopupEnum["UserInfo"] = "userInfo";
    HeaderPopupEnum["AppSwitcher"] = "appSwitcher";
    HeaderPopupEnum["Search"] = "search";
})(HeaderPopupEnum || (exports.HeaderPopupEnum = HeaderPopupEnum = {}));
